import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-shared-loading-bar',
    templateUrl: './shared-loading-bar.component.html',
    styleUrls: ['./shared-loading-bar.component.scss'],
    standalone: false
})
export class SharedLoadingBarComponent {

  @Input() ariaLabel = '';
  @Input() barPercentile = 0;
  @Input() barText = '';
  @Input() barSize: 'small' | 'medium' | 'large' = 'medium';
  @Input() isBaPercentileVisible = false;
  @Input() isBarTextVisible = false;
  @Input() isBorderVisible = false;
  @Input() isError: boolean;

  get getAriaLabel(): string {
    return this.ariaLabel;
  }

  get getAriaValueText(): string {
    const value = this.getBarPercentile;
    const text = this.getDisplayText;
    return text ? `${text} ${value}%` : `${value}%`;
  }

  get getBarText(): string {
    return this.barText;
  }

  get getBarPercentile(): number {
    return this.barPercentile ?? 0;
  }

  get getDisplayText(): string {
    return this.isBarTextVisible === true ? this.getBarText : '';
  }

  get getDisplayPercentile(): string {
    return this.isBaPercentileVisible === true ? `${this.getBarPercentile}%` : '';
  }

  get getIsError(): boolean {
    return this.isError;
  }

}
